import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import createSagaMiddleware from 'redux-saga'
import { createLogger } from 'redux-logger'
import { syncTranslationWithStore, loadTranslations, setLocale } from 'react-redux-i18n'

import reducers from '../reducers'
import sagas from '../sagas'
import translations from '../i18n'

const sagaMiddleware = createSagaMiddleware()
const loggerMiddleware = createLogger({
  predicate: (getState, action) => process.env.NODE_ENV !== 'production'
})

export default function configureStore(preloadedState = {}, ...middlewares) {
  const store = createStore(
    reducers,
    preloadedState,
    applyMiddleware(
      thunkMiddleware,
      sagaMiddleware,
      loggerMiddleware,
      ...middlewares
    )
  )
  sagaMiddleware.run(sagas)

  syncTranslationWithStore(store)
  store.dispatch(loadTranslations(translations))
  store.dispatch(setLocale('cht'))
  return store
}


// WEBPACK FOOTER //
// ./src/configs/configureStore.js